import { useState } from 'react';

const navLinks = [
  { label: 'Services', href: '#services' },
  { label: 'Why Us', href: '#benefits' },
  { label: 'Testimonials', href: '#testimonials' },
  { label: 'Contact', href: '#contact' },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleNav = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav className="fixed top-0 left-0 w-full z-50 bg-black">
      {/* Emergency banner */}
      <div className="bg-orange-600 text-white text-xs text-center py-2 px-4 tracking-wide">
        <span className="font-semibold">24-Hour Emergency Service</span>
        &nbsp;&mdash;&nbsp;Serving New Jersey &amp; Pennsylvania&nbsp;&mdash;&nbsp;
        <a href="tel:8566776191" className="underline hover:no-underline cursor-pointer whitespace-nowrap">
          Call Now: (856) 677-6191
        </a>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        {/* Logo */}
        <a
          href="#"
          className="flex items-center gap-2 cursor-pointer"
          onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
        >
          <div className="w-8 h-8 flex items-center justify-center bg-orange-600">
            <i className="ri-building-2-line text-white text-base" />
          </div>
          <span className="text-base font-display font-semibold tracking-tight text-white whitespace-nowrap">
            Commercial Roofing <span className="font-light text-gray-400">NJ</span>
          </span>
        </a>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <button
              key={link.label}
              onClick={() => handleNav(link.href)}
              className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </button>
          ))}
          <a
            href="tel:8566776191"
            className="ml-2 flex items-center gap-2 px-5 py-2 bg-orange-600 text-white text-sm font-medium hover:bg-orange-500 transition-colors cursor-pointer whitespace-nowrap"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-line text-xs" />
            </span>
            (856) 677-6191
          </a>
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden w-8 h-8 flex flex-col justify-center items-center gap-1.5 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span className={`block w-5 h-0.5 bg-white transition-all ${menuOpen ? 'rotate-45 translate-y-2' : ''}`} />
          <span className={`block w-5 h-0.5 bg-white transition-all ${menuOpen ? 'opacity-0' : ''}`} />
          <span className={`block w-5 h-0.5 bg-white transition-all ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`} />
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-gray-950 border-t border-white/10 px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <button
              key={link.label}
              onClick={() => handleNav(link.href)}
              className="text-sm text-gray-300 text-left cursor-pointer hover:text-white whitespace-nowrap"
            >
              {link.label}
            </button>
          ))}
          <a
            href="tel:8566776191"
            className="mt-1 flex items-center gap-2 px-5 py-2 bg-orange-600 text-white text-sm font-medium hover:bg-orange-500 transition-colors cursor-pointer whitespace-nowrap w-fit"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-line text-xs" />
            </span>
            (856) 677-6191
          </a>
        </div>
      )}
    </nav>
  );
}
